import { render, staticRenderFns } from "./ModalConfirmationBody.vue?vue&type=template&id=80039ecc"
import script from "./ModalConfirmationBody.vue?vue&type=script&lang=js"
export * from "./ModalConfirmationBody.vue?vue&type=script&lang=js"
import style0 from "./ModalConfirmationBody.vue?vue&type=style&index=0&id=80039ecc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports